"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DnpMetadataValue = void 0;
class DnpMetadataValue {
    static { this.UNAMBIGUOUS_MARKERS = [
        'dnp',
        'dni',
        'dnf',
        'dns',
        'nopop',
        'no_stuff',
        'no-stuff',
        'nostuff',
        'no stuff',
        'not fitted',
        'not_fitted',
        'nofit',
        'not placed',
        'not_placed',
        'do not populate',
        'do_not_populate',
        'not populated',
        'do not place',
        'do_not_place',
    ]; }
    static { this.AMBIGUOUS_MARKERS = ['nc', 'nm', 'ni']; }
    static { this.MARKER_PATTERNS = DnpMetadataValue.buildMarkerPatterns(); }
    static normalize(raw) {
        if (raw === undefined || raw === null || typeof raw === 'object') {
            return null;
        }
        const text = String(raw).trim();
        return text.length > 0 ? text.toLowerCase() : null;
    }
    static isMarker(raw) {
        const normalized = DnpMetadataValue.normalize(raw);
        if (normalized === null) {
            return false;
        }
        return DnpMetadataValue.MARKER_PATTERNS.some((pattern) => pattern.test(normalized));
    }
    static buildMarkerPatterns() {
        const alternation = (markers) => [...markers]
            .sort((a, b) => b.length - a.length)
            .map((marker) => marker.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/ /g, '\\s+'))
            .join('|');
        const any = alternation([...DnpMetadataValue.UNAMBIGUOUS_MARKERS, ...DnpMetadataValue.AMBIGUOUS_MARKERS]);
        const unambiguous = alternation(DnpMetadataValue.UNAMBIGUOUS_MARKERS);
        const ambiguous = alternation(DnpMetadataValue.AMBIGUOUS_MARKERS);
        const open = '[(<\\[]?';
        const close = '[)>\\]]?';
        return [
            new RegExp(`^${open}(?:${any})${close}$`),
            new RegExp(`^${open}(?:${unambiguous})${close}(?=[\\s_/:(])`),
            new RegExp(`^${open}(?:${ambiguous})${close}(?=[_/:(]|\\s+\\()`),
            new RegExp(`(?:^|\\s)[(<\\[](?:${any})[)>\\]](?=\\s|$)`),
            new RegExp(`(?:^|\\s)(?:${unambiguous})(?=\\s|$)`),
        ];
    }
}
exports.DnpMetadataValue = DnpMetadataValue;
//# sourceMappingURL=dnp-metadata-value.js.map